// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","headerTitle":"_3wpKgRU3GzTprzZwDp-NJY","headerPostedAt":"_2fStReu6fSoV-2rrV7dAOW","headerDivider":"_1dSpswGE8CBIymFFZg-3Y0"};